import { React, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Loader } from 'rsuite';
import Modal from 'react-bootstrap/Modal';
import { ShimmerThumbnail, ShimmerBadge } from "react-shimmer-effects";
import Select from "react-select";
import 'animate.css';


export default function Banner(prop) {
    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
    const { showLoaderLine } = prop
    const vehicalDetails = JSON.parse(localStorage.getItem('vehical_details'));
    const wheelsDetails = JSON.parse(localStorage.getItem('wheels_details'));
    const tireDetails = JSON.parse(localStorage.getItem('tire_details'));
    const navigate = useNavigate();
    const [dataYear, setDataYear] = useState('');
    const [dataMake, setDataMake] = useState('');
    const [dataModel, setDataModel] = useState('');
    const [dataModelVarient, setDataVarient] = useState('');
    // const [vehicalId, setVehicalId] = useState('');


    const [showMake, setShowMake] = useState(false);
    const [showModel, setShowModel] = useState(false);
    const [showVarient, setShowVarient] = useState(false);

    const [isOpenMake, setisOpenMake] = useState(false);
    const [isOpenModel, setisOpenModel] = useState(false);
    const [isOpenVarient, setisOpenVarient] = useState(false);


    const [selectedYear, setSelectedYear] = useState(vehicalDetails ? vehicalDetails.year : "Year");
    const [selectedMake, setSelectedMake] = useState(vehicalDetails ? vehicalDetails.make : "");
    const [selectedModel, setSelectedModel] = useState(vehicalDetails ? vehicalDetails.model : "");
    const [selectedVariant, setSelectedVariant] = useState(vehicalDetails ? vehicalDetails.variant : "");

    // const [selectedYear, setSelectedYear] = useState(vehicalDetails ? vehicalDetails.year : "");
    const [selectedMakeName, setSelectedMakeName] = useState(vehicalDetails ? vehicalDetails.make_name : "Make");
    const [selectedModelName, setSelectedModelName] = useState(vehicalDetails ? vehicalDetails.model_name : "Model");
    const [selectedVariantName, setSelectedVariantName] = useState(vehicalDetails ? vehicalDetails.variant_name : "Sub model");


    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingMake, setIsLoadingMake] = useState(true);
    const [isLoadingModel, setIsLoadingModel] = useState(true);
    const [isLoadingVarient, setIsLoadingVarient] = useState(true);


    const [isLoaderMake, setIsLoaderMake] = useState(true);
    const [isLoaderModel, setIsLoaderModel] = useState(true);
    const [isLoaderVarient, setIsLoaderVarient] = useState(true);


    const [dataProducts, setdataProducts] = useState(0);
    const [dataBrands, setdataBrands] = useState(0);

    const [activeTab, setActiveTab] = useState(0);

    const [isLoadingFilterData, setLoadingFilterData] = useState(true);
    const [isWheelsFilterData, setWheelsFilterData] = useState([]);

    const [dataBrandsWheels, setDataBrandsWheels] = useState([]);
    const [isLoadingBrands, setIsLoadingBrands] = useState(true);

    // const [valueDiameter, setValueDiameter] = useState('');
    // const [valueWidth, setValueWidth] = useState('');
    // const [valueLugPattern, setValueLugPattern] = useState('');
    // const [valueBrandId, setValueBrandId] = useState('');


    const [dataCategory, setDataCategory] = useState([]);
    const [isLoadingCategory, setIsLoadingCategory] = useState(true);

    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');


    const [showWheel, setShowWheel] = useState(false);

    const [fmkApiData, setFmkApiData] = useState('');
    const [isLoadingFmkData, setisLoadingFmkData] = useState(false);

    const [uniqueRimDiameters, setuniqueRimDiameters] = useState([])
    const [responseFromApi, setResponseFromApi] = useState("");




    const [daimeterData, setDaimeterData] = useState("");
    const [selectedDiameter, setSelectedDiameter] = useState(wheelsDetails ? wheelsDetails.diameter : "Wheel Diameter");

    const [wheelWidthData, setWheelWidthData] = useState("");
    const [selectedWheelWidth, setSelectedWheelWidth] = useState(wheelsDetails ? wheelsDetails.width : "Wheel Width");
    const [isOpenWheelWidth, setisOpenWheelWidth] = useState(false);

    const [wheelLugPatternData, setWheelLugPatternData] = useState("");
    const [selectedWheelLugPattern, setSelectedWheelLugPattern] = useState(wheelsDetails ? wheelsDetails.pattern : "Wheel Pattern");
    const [isOpenWheelLugPattern, setisOpenWheelLugPattern] = useState(false);

    const [wheelBrandData, setWheelBrandData] = useState("");
    const [selectedWheelBrand, setSelectedWheelBrand] = useState(wheelsDetails ? wheelsDetails.brandId : "Wheel Brand");
    const [isOpenWheelBrand, setisOpenWheelBrand] = useState(false);

    const [selectedWheelBrandName, setSelectedWheelBrandName] = useState(wheelsDetails ? wheelsDetails.brndName : "Wheel Brand");


    const makeRef = useRef(null);
    const modelRef = useRef(null);
    const variantRef = useRef(null);

    const widthRef = useRef(null);
    const lugRef = useRef(null);
    const brandidRef = useRef(null);


    const ratioRef = useRef(null);
    const tireDiameterRef = useRef(null);
    const tireBrandRef = useRef(null);


    const [tireWidthData, setTireWidthData] = useState("");
    const [selectedTireWidth, setselectedTireWidth] = useState(tireDetails ? tireDetails.width : "Tire Height");

    const [tireDiameterData, setTireDiameterData] = useState("");
    const [selectedTireDiameter, setselectedTireDiameter] = useState(tireDetails ? tireDetails.diameter : "Tire Diameter");

    const [tireRatioData, setTireRatioData] = useState("");
    const [selectedTireRatio, setselectedTireRatio] = useState(tireDetails ? tireDetails.ratio : "Tire Ratio");

    const [tireBrandData, setTireBrandData] = useState("");
    const [selectedTireBrand, setselectedTireBrand] = useState(tireDetails ? tireDetails.brand : "Tire Brand");
    const [selectedTireBrandName, setselectedTireBrandName] = useState(tireDetails ? tireDetails.brandName : "Tire Brand");


    const [isOpenTireDiameterData, setisOpenTireDiameterData] = useState(false);
    const [isOpenTireRatioData, setisOpenTireRatioData] = useState(false);
    const [isOpenTireBrandData, setisOpenTireBrandData] = useState(false);





    useEffect(() => {
        fetchYearData();
        fetchCount();
        fetchWheelBrandsData();
        fetchWheelsFiltersData();
        fetchWheelsDiamtere();
        fetchTireWidth();
    }, []);




    const handleShow = () => {
        showLoaderLine(1);
        let state = {
            year: selectedYear,
            make: selectedMake,
            model: selectedModel,
            variant: selectedVariant,
            make_name: selectedMakeName,
            model_name: selectedModelName,
            // variant_name: selectedVariantName,
            variant_name: selectedVariantName === "Sub Model" ? "" : selectedVariantName,

        }
        // Save state in local storage
        localStorage.setItem('vehical_details', JSON.stringify(state));
        localStorage.removeItem('wheels_details');
        localStorage.removeItem('vehical_fitment');
        // Retrieve state from local storage       

        setTimeout(() => {
            navigate(`/categories-home/all-category`);
        }, 500); // Delay of 2000 milliseconds (2 seconds)s
    };
    const handleClose = () => {
        setShow(false);
        setIsLoadingCategory(true);
    };
    const handleCloseWheel = () => {
        setShowWheel(false);
    };

    const fetchWheelBrandsData = async () => {

        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/getWheelsBrandData`,
            };
            axios.request(config)
                .then((response) => {
                    setDataBrandsWheels(response.data);
                    setIsLoadingBrands(false);
                })
                .catch((error) => {
                    console.log(error);


                });

        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoadingBrands(false);
            navigate("/error");



        }

    }

    const fetchWheelsFiltersData = async () => {
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/wheels/getWheelsFiltersData`,
            };
            axios
                .request(config)
                .then((response) => {
                    setWheelsFilterData(response.data)
                    setLoadingFilterData(false)

                })
                .catch((error) => {
                    console.log(error);
                    setLoadingFilterData(false)

                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoadingFilterData(false)
            navigate("/error");


        }
    }

    const fetchWheelsDiamtere = async () => {
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/wheels/getWheelsDiameter`,
            };
            axios
                .request(config)
                .then((response) => {


                    const filteredData = response.data.data.filter(item => item.value !== '0');

                    setDaimeterData(filteredData)
                    if (selectedDiameter) {
                        fetchWheelWidth(selectedDiameter);
                    }

                })
                .catch((error) => {
                    console.log(error);


                });

        } catch (error) {
            navigate("/error");

        }
    }

    const fetchWheelWidth = async (diameter) => {
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/wheels/getWheelsWidthOnDiameter/${diameter}`,
            };
            axios
                .request(config)
                .then((response) => {

                    setWheelWidthData(response.data)
                    if (selectedDiameter && selectedWheelWidth) {
                        fetchWheelLugPattern(selectedDiameter, selectedWheelWidth);
                    }

                })
                .catch((error) => {
                    console.log(error);


                });

        } catch (error) {
            navigate("/error");


        }
    }

    const fetchWheelLugPattern = async (diameter, width) => {
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/wheels/getWheelsLugPatternFilter/${diameter}/${width}`,
            };
            axios
                .request(config)
                .then((response) => {

                    setWheelLugPatternData(response.data)
                    if (selectedDiameter && selectedWheelWidth && selectedWheelLugPattern) {
                        fetchWheelBrand(selectedDiameter, selectedWheelWidth, selectedWheelLugPattern);
                    }

                })
                .catch((error) => {
                    console.log(error);


                });

        } catch (error) {
            navigate("/error");


        }

    }

    const fetchWheelBrand = async (diameter, width, lugpattern) => {
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/wheels/getWheelsBrandsFilter/${diameter}/${width}/${lugpattern}`,
            };
            axios
                .request(config)
                .then((response) => {

                    setWheelBrandData(response.data)

                })
                .catch((error) => {
                    console.log(error);


                });

        } catch (error) {

            navigate("/error");

        }

    }


    const fetchCount = async () => {
        setIsLoading(true);
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/getCountProductsBrands`,
            };
            axios
                .request(config)
                .then((response) => {

                    setdataProducts(response.data.data.count);
                    setdataBrands(response.data.data.brandCount);
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                    setIsLoading(false);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoading(false);
            navigate("/error");

        }
    };


    const fetchYearData = async () => {
        setIsLoading(true);
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/getYear`,
            };
            axios
                .request(config)
                .then((response) => {
                    setDataYear(response.data);
                    setIsLoading(false);
                    if (selectedYear) {
                        fetchMakeData(selectedYear);
                    }

                })
                .catch((error) => {
                    console.log(error);
                    setIsLoading(false);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoading(false);
            navigate("/error");

        }
    };




    const handleYearChange = (event) => {

        setisOpenVarient(false);
        setisOpenModel(false);
        const selectedYear = event.value
        if (selectedYear === "") {
            setSelectedMake('');
            setSelectedModel('');
            setSelectedVariant('');
            setDataMake("")
            setDataModel("")
            setDataVarient("")

            setSelectedMakeName('')
            setSelectedModelName('')
            setSelectedVariantName('')

        } else {
            setSelectedYear(selectedYear);
            setSelectedMake('');
            setSelectedModel('');
            setSelectedVariant('');
            fetchMakeData(selectedYear);
            setIsLoaderMake(false);
            setShowMake(true)
            setSelectedMakeName('Make')
            setSelectedModelName('Model')
            setSelectedVariantName('Sub Model')
            setTimeout(() => {
                setisOpenMake(true);
            }, 500);

            makeRef.current?.focus();

        }

    };

    const fetchMakeData = async (selectedYear) => {

        if (selectedYear) {
            setIsLoadingMake(true);
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getMakeByYear/${selectedYear}`,
                };
                axios
                    .request(config)
                    .then((response) => {
                        setIsLoadingMake(false);
                        setDataMake(response.data);
                        setIsLoaderMake(true);

                        if (selectedYear && selectedMake) {
                            fetchModelData(selectedYear, selectedMake);
                        }

                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoadingMake(false);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoadingMake(false);
                navigate("/error");

            }
        }
    };

    const handleMakeChange = (event) => {
        setisOpenVarient(false);
        const selectedMake = event.value;
        const selectedMakeName = event.label;
        setSelectedMake(selectedMake);
        setSelectedMakeName(selectedMakeName);
        setisOpenMake(false)
        // setDataMake([]);
        setDataModel([]);
        setSelectedModel('');
        setSelectedVariant('');
        // Fetch model data based on selected year and make
        setIsLoaderModel(false)
        fetchModelData(selectedYear, selectedMake);
        setShowModel(true)
        setTimeout(() => {
            setisOpenModel(true)
        }, 500);


        // setSelectedModelName('')
        // setSelectedVariantName('')
        setSelectedModelName('Model')
        setSelectedVariantName('Sub Model')
        modelRef.current?.focus();
    };

    const fetchModelData = async (selectedYear, selectedMake) => {
        if (selectedYear && selectedMake) {
            setIsLoadingModel(true);
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getModelByMake/${selectedYear}/${selectedMake}`,
                };
                axios
                    .request(config)
                    .then((response) => {

                        setIsLoadingModel(false);
                        setDataModel(response.data);
                        setIsLoaderModel(true)
                        if (selectedYear && selectedModel) {
                            fetchVariantData(selectedYear, selectedModel);
                        }

                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoadingModel(false);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoadingModel(false);
                navigate("/error");

            }
        }
    };

    const handleModelChange = (event) => {
        setisOpenModel(false)
        const selectedModel = event.value;
        const selectedModelName = event.label;
        setSelectedModel(selectedModel);
        setSelectedModelName(selectedModelName);
        setSelectedVariant('');
        // setSelectedVariantName('')
        setSelectedVariantName('Sub Model')

        // Fetch variant data based on selected year, make, and model
        fetchVariantData(selectedYear, selectedModel);
        setIsLoaderVarient(false)
        setShowVarient(true)
        setTimeout(() => {
            setisOpenVarient(true)
        }, 500);


        variantRef.current?.focus();
    };

    const fetchVariantData = async (selectedYear, selectedModel) => {
        if (selectedYear && selectedModel) {
            setIsLoadingVarient(true);
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getSubModelByModel/${selectedYear}/${selectedModel}`,
                };
                axios
                    .request(config)
                    .then((response) => {

                        setIsLoadingVarient(false);
                        setDataVarient(response.data);
                        setIsLoaderVarient(true)
                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoadingVarient(false);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoadingVarient(false);
                navigate("/error");

            }
        }
    };

    const handleVarientChange = (event) => {
        setisOpenVarient(false)
        const selectedVarient = event.value;
        const selectedVarientName = event.label
        setSelectedVariant(selectedVarient);
        setSelectedVariantName(selectedVarientName);

    };
    const handleChangePage = async (id) => {
        let state = {
            year: selectedYear,
            make: selectedMake,
            model: selectedModel,
            variant: selectedVariant,
        }
        if (id === 19) {
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getVehicalId/${selectedYear}/${selectedMake}/${selectedModel}/${selectedVariant}`,

                };
                axios.request(config)
                    .then((response) => {
                        // setVehicalId(response.data ? response.data.data : "");

                        fetchWheelsDetailsFromApi(response.data.data);
                    })
                    .catch((error) => {
                        console.log(error);
                    });

            } catch (error) {
                console.log('error', error);
                navigate("/error");

            }

        } else {
            setIsLoaderMake(false)
            setIsLoaderModel(false)
            setIsLoaderVarient(false)
            setIsLoading(true)
            setTimeout(() => {
                navigate(`/search-accesories-by-vehical/${id}`, { state: state });
            }, 2000);
        }

    };


    const fetchWheelsDetailsFromApi = (vehicalIds) => {
        setShowWheel(true);
        setShow(false);
        setisLoadingFmkData(true)
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `https://api.fitmentatlas.com/v1.1/services/Vehicles/${vehicalIds}`,
                headers: {
                    'FG-ApiKey': 'crQqKW9uFVL1bSu1uymaWx2UFTcvgdKE'
                }
            };
            axios.request(config)
                .then((response) => {
                    if (response.data.result) {
                        let diameter = response.data.result.vehicleChassis.vehiclePlusSizes;
                        setResponseFromApi(diameter);
                        if (diameter) {
                            // Extract unique rim diameters
                            let RimDiameters = [...new Set(diameter.map(item => item.rimDiameter))];
                            setuniqueRimDiameters(RimDiameters);
                        }

                    }
                    setFmkApiData(response.data.result)
                    setisLoadingFmkData(false);

                })
                .catch((error) => {
                    console.log(error);
                    setisLoadingFmkData(false);
                });

        } catch (error) {
            console.log('error', error);
            setisLoadingFmkData(false);
            navigate("/error");


        }
    }

    const fetchTireWidth = () => {
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/tires/getTireWitdhForDropDown`,
            };
            axios
                .request(config)
                .then((response) => {
                    setTireWidthData(response.data);

                })
                .catch((error) => {
                    console.log(error);
                    navigate("/error");
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoadingVarient(false);
            navigate("/error");
        }
    }


    const fetchTiresDiameter = (width, ratio) => {
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/tires/getTireDiameterForDropDown?width=${width}&ratio=${ratio}`,
            };
            axios
                .request(config)
                .then((response) => {
                    setTireDiameterData(response.data);
                    setisOpenTireDiameterData(true)
                    setisOpenTireRatioData(false)


                })
                .catch((error) => {
                    console.log(error);
                    navigate("/error");
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoadingVarient(false);
            navigate("/error");
        }
    }




    const fetchTiresRatio = (width) => {
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/tires/getTireRatioForDropDown?width=${width}`,
            };
            axios
                .request(config)
                .then((response) => {
                    setTireRatioData(response.data);
                    setisOpenTireRatioData(true)

                })
                .catch((error) => {
                    console.log(error);
                    navigate("/error");
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoadingVarient(false);
            navigate("/error");
        }
    }

    const fetchTiresBrands = (width, diameter, ratio) => {
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/tires/getTireBrandsForDropDown?diameter=${diameter}&width=${width}&ratio=${ratio}`,
            };
            axios
                .request(config)
                .then((response) => {
                    setTireBrandData(response.data);
                    setisOpenTireBrandData(true)
                    setisOpenTireRatioData(false)
                    setisOpenTireDiameterData(false)


                })
                .catch((error) => {
                    console.log(error);
                    navigate("/error");
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoadingVarient(false);
            navigate("/error");
        }
    }



    const changeTabItems = () => {
        setActiveTab(0);
    }
    const changeWheels = () => {
        setActiveTab(1);
    }
    const changeTires = () => {
        setActiveTab(2);
    }





    const handleDiameterChange = (event) => {

        const diameter = event.value;
        setSelectedDiameter(diameter);
        setSelectedWheelWidth("Wheel Width");
        setSelectedWheelLugPattern("Wheel Pattern");
        setSelectedWheelBrandName("Wheel Brand")
        setSelectedWheelBrand("");
        fetchWheelWidth(diameter);
        setisOpenWheelWidth(true)
        widthRef.current?.focus();


    }

    const handleWidthChange = (event) => {
        const width = event.value;
        setSelectedWheelWidth(width);
        setSelectedWheelLugPattern("Wheel Pattern");
        setSelectedWheelBrandName("Wheel Brand")
        setSelectedWheelBrand("");
        fetchWheelLugPattern(selectedDiameter, width);
        setisOpenWheelLugPattern(true)
        lugRef.current?.focus();
    }

    const handleLugPatternChange = (event) => {
        const lugpatter = event.value;
        setSelectedWheelLugPattern(lugpatter);
        setSelectedWheelBrandName("Wheel Brand")
        setSelectedWheelBrand("");
        fetchWheelBrand(selectedDiameter, selectedWheelWidth, lugpatter);
        setisOpenWheelBrand(true)
        brandidRef.current?.focus();
    }
    const handleBrandChange = (event) => {
        const brand = event.value;
        const brandName = event.label
        setSelectedWheelBrandName(brandName)
        setSelectedWheelBrand(brand);
        setisOpenTireBrandData(false)


    }
    const handleWheelsSubmit = (event) => {

        setIsLoading(true)
        let brandName = "";
        let brandId = "";
        if (selectedWheelBrandName == 'Wheel Brand' || selectedWheelBrandName == "All") {
            brandName = ""
            brandId = ""
        } else {
            brandName = selectedWheelBrandName
            brandId = selectedWheelBrand
        }

        let state = {
            diameter: selectedDiameter,
            width: selectedWheelWidth,
            pattern: selectedWheelLugPattern,
            brandId: brandId,
            brndName: brandName
        }

        localStorage.setItem('wheels_details', JSON.stringify(state));
        localStorage.removeItem('vehical_details');
        localStorage.removeItem('vehical_fitment');
        localStorage.removeItem('setSwheelsDiameterArray');
        localStorage.removeItem('setSwheelsWidthArray');
        localStorage.removeItem('setSwheelsPatternArray');
        localStorage.removeItem('setSwheelsBradArray');
        localStorage.removeItem('setSwheelsBradNameArray');
        localStorage.removeItem('setSwheelsModelArray');
        localStorage.removeItem('setSwheelsWheelOffsetArray');
        localStorage.removeItem('setSwheelsColourWheel');
        localStorage.removeItem('setSwheelsFirstValue');
        localStorage.removeItem('setSwheelsMaxPrice');
        localStorage.removeItem('setSwheelsMinPrice');
        localStorage.removeItem('setSwheelsStockWheel');
        localStorage.removeItem('setSwheelsSecondValue');
        localStorage.removeItem('setWheelDiameterArray');
        localStorage.removeItem('setWheelWidthArray');
        localStorage.removeItem('setWheelPatternArray');
        localStorage.removeItem('setWheelBradArray');
        localStorage.removeItem('setWheelBradNameArray');
        localStorage.removeItem('setWheelWheelOffsetArray');
        localStorage.removeItem('setWheelModelArray');
        localStorage.removeItem('setWheelMaxPrice');
        localStorage.removeItem('setWheelMinPrice');
        localStorage.removeItem('setWheelFirstValue');
        localStorage.removeItem('setWheelSecondValue');
        localStorage.removeItem('setWheelColourWheel');
        localStorage.removeItem('setWheelStockWheel');
        localStorage.removeItem('setWheelIsCheckedStock');
        localStorage.removeItem('setWheelSortingValue');
        localStorage.removeItem('setWheeloffsetCurrentPage');
        localStorage.removeItem('setWheelCurrentPage');
        localStorage.removeItem('setWheelsDiameterArray');
        localStorage.removeItem('setWheelsWidthArray');
        localStorage.removeItem('setWheelsPatternArray');
        localStorage.removeItem('setWheelsBradArray');
        localStorage.removeItem('setWheelsBradNameArray');
        localStorage.removeItem('setWheelsWheelOffsetArray');
        localStorage.removeItem('setWheelsModelArray');
        localStorage.removeItem('setWheelsMaxPrice');
        localStorage.removeItem('setWheelsMinPrice');
        localStorage.removeItem('setWheelsFirstValue');
        localStorage.removeItem('setWheelsSecondValue');
        localStorage.removeItem('setWheelsColourWheel');
        localStorage.removeItem('setWheelsStockWheel');



        setLoadingFilterData(true);
        setTimeout(() => {
            navigate(`/wheels-search?diameter=${selectedDiameter}&width=${selectedWheelWidth}&pattern=${selectedWheelLugPattern}&brandid=${brandId}&brandName=${brandName}`);
        }, 1000); // Delay of 1000 milliseconds (2 seconds)
    };

    const handleClickDiameter = (diameter) => {
        let responseData = responseFromApi;
        const rimDiameter = responseData.filter((config) => config.rimDiameter === diameter);
        const offsetMinValues = rimDiameter.map((config) => config.offsetMin);
        const offsetMaxValues = rimDiameter.map((config) => config.offsetMax);
        const minOffsetMin = Math.min(...offsetMinValues);
        const maxOffsetMin = Math.max(...offsetMaxValues);
        let stateData = {
            year: selectedYear,
            make: selectedMake,
            model: selectedModel,
            variant: selectedVariant,
            diameter: diameter,
            minoffset: minOffsetMin,
            maxoffset: maxOffsetMin,
            centerbor: "",
            width: "",
            lugpattern: ""
        }
        setTimeout(() => {
            navigate(`/wheels-search-by-vehical/${diameter}`, { state: stateData });
        }, 1000);
    }

    const isOptionSelected = (option) => {
        if (!selectedVariant) {
            return false;
        }

        return (
            selectedVariant === option.value &&
            selectedVariantName.toLowerCase() === option.label.toLowerCase()
        );
    };


    const handleTireSubmit = (event) => {

        // console.log('selectedTireWidth', selectedTireWidth)
        // console.log('selectedTireDiameter', selectedTireDiameter)
        // console.log('selectedTireRatio', selectedTireRatio)
        // console.log('selectedTireRatio', selectedTireBrand)
        // console.log('selectedTireRatio', selectedTireBrandName)

        let brandName = "";
        let brandId = "";
        if (selectedTireBrandName == 'Tire Brand' || selectedTireBrandName == "All") {
            brandName = ""
            brandId = ""
        } else {
            brandName = selectedTireBrandName
            brandId = selectedTireBrand
        }

        // localStorage.setItem('tire_details', JSON.stringify(state));
        localStorage.removeItem('vehical_details');
        localStorage.removeItem('wheels_details');
        localStorage.removeItem('vehical_fitment');

        localStorage.removeItem('setDiameterArray');
        localStorage.removeItem('setWidthArray');
        localStorage.removeItem('setPatternArray');
        localStorage.removeItem('setBradArray');
        localStorage.removeItem('setBradNameArray');
        localStorage.removeItem('setcategoryArray');
        localStorage.removeItem('setcategoryNameArray');
        localStorage.removeItem('setModelArray');
        localStorage.removeItem('setMaxPrice');
        localStorage.removeItem('setMinPrice');
        localStorage.removeItem('setFirstValue');
        localStorage.removeItem('setSecondValue');
        localStorage.removeItem('setSpeedLoadRange');
        localStorage.removeItem('setSpeedRatingArray');
        localStorage.removeItem('setratioArray');
        localStorage.removeItem('setPlyArray');
        localStorage.removeItem('setSideWallArray');
        localStorage.removeItem('setMilageRatingArray');
        localStorage.removeItem('setRunFlat');
        localStorage.removeItem('setstuddable');
        localStorage.removeItem('settiresizes');
        localStorage.removeItem('setoffsetCurrentPage');
        localStorage.removeItem('setCurrentPage');


        setTimeout(() => {
            navigate(`/tires/tires-tab-search?diameter=${selectedTireDiameter}&width=${selectedTireWidth}&ratio=${selectedTireRatio}&brandid=${brandId}&brandName=${brandName}`);
        }, 1000);
    }



    const handleTireWidthChange = (event) => {

        const width = event.value;
        setselectedTireWidth(width);
        setselectedTireDiameter("Tire Diameter");
        setselectedTireRatio("Tire Ratio");
        setselectedTireBrandName("Tire Brand");
        setselectedTireBrand("Tire Brand");
        fetchTiresRatio(width);
        ratioRef.current?.focus();


    }



    const handleTireRatioChange = (event) => {

        const ratio = event.value;
        const width = selectedTireWidth;
        setselectedTireRatio(ratio);
        setselectedTireBrandName("Tire Brand");
        setselectedTireBrand("Tire Brand");
        fetchTiresDiameter(width, ratio);
        tireDiameterRef.current?.focus();

    }


    const handleTireDiameterChange = (event) => {

        const diameter = event.value;
        const width = selectedTireWidth;
        const ratio = selectedTireRatio;
        setselectedTireDiameter(diameter);
        fetchTiresBrands(width, diameter, ratio);
        setselectedTireBrandName("Tire Brand");
        setselectedTireBrand("Tire Brand");
        tireBrandRef.current?.focus();

    }




    const handleTireBrandChange = (event) => {
        const brand = event.value;
        const brandName = event.label
        setselectedTireBrand(brand);
        setselectedTireBrandName(brandName)



    }

    return (
        <div>
            {/* <!-- banner section start  --> */}

            <section>


                <div className="main-banner">

                    <picture className="main-banner-image">
                        <source
                            media="(max-width: 767px)"
                            // srcSet="/images/bg_mobile_banner.jpg"
                            srcSet="/images/webp/bg_mobile_banner.webp"
                        />

                        <img
                            // src="/images/banner_bg.jpg"
                            src="/images/webp/banner_bg.webp"
                            alt=""
                            fetchPriority="high"
                            loading="eager"
                            decoding="sync"
                        />
                    </picture>


                    <div className="container">
                        {/* <div className='five_percent_homepage'><img src='../icons/homepage_discount.png' /></div> */}
                        <div className="banner-under-data" data-aos="fade-right">

                            <h2>Looking for accessories for your car?</h2>
                            <p>
                                You are at the right place! Choose your vehicle's year make model and go for it.
                            </p>
                            {/* <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation" onClick={changeTabItems}>
                                    <button className={`nav-link tabs-accorind ${activeTab === 0 ? 'active' : ''}`} id="pills-home-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">
                                        <i className="fa fa-car" title="Search by Vehicle"></i>  <span className="btn-text-uppar">Search by Vehicle</span>
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation" onClick={changeWheels}>
                                    <button className={`nav-link tabs-accorind ${activeTab === 1 ? 'active' : ''}`} id="pills-profile-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
                                        aria-selected="false">
                                        <i className="fa fa-car" title="Wheels by size & brand"></i>   <span className="btn-text-uppar">Wheels by Size & Brand</span>
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation" onClick={changeTires}>
                                    <button className={`nav-link tabs-accorind ${activeTab === 2 ? 'active' : ''}`} id="pills-contact-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact"
                                        aria-selected="false">
                                        <i className="fa fa-car"></i>   <span className="btn-text-uppar">Search Tires</span>
                                    </button>
                                </li>
                            </ul> */}

                            <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation" onClick={changeTabItems}>
                                    <button
                                        className={`nav-link tabs-accorind ${activeTab === 0 ? 'active' : ''}`}
                                        id="pills-home-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-home"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-home"
                                        aria-selected={activeTab === 0}
                                        aria-label="Search by Vehicle"
                                    >
                                        <i className="fa fa-car" aria-hidden="true"></i>
                                        <span className="btn-text-uppar">Search by Vehicle</span>
                                    </button>
                                </li>

                                <li className="nav-item" role="presentation" onClick={changeWheels}>
                                    <button
                                        className={`nav-link tabs-accorind ${activeTab === 1 ? 'active' : ''}`}
                                        id="pills-profile-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-profile"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-profile"
                                        aria-selected={activeTab === 1}
                                        aria-label="Wheels by Size & Brand"
                                    >
                                        <i className="fa fa-car" aria-hidden="true"></i>
                                        <span className="btn-text-uppar">Wheels by Size & Brand</span>
                                    </button>
                                </li>

                                <li className="nav-item" role="presentation" onClick={changeTires}>
                                    <button
                                        className={`nav-link tabs-accorind ${activeTab === 2 ? 'active' : ''}`}
                                        id="pills-contact-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-contact"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-contact"
                                        aria-selected={activeTab === 2}
                                        aria-label="Search Tires"
                                    >
                                        <i className="fa fa-car" aria-hidden="true"></i>
                                        <span className="btn-text-uppar">Search Tires</span>
                                    </button>
                                </li>
                            </ul>

                            <div className="tab-content " id="pills-tabContent">
                                <div className={`tab-pane fade animate__fadeIn ${activeTab === 0 ? 'show active' : ''}`} id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                    <div className="mian-inner-data-tab position-relative d-flex">
                                        <div className='selectMainDiv'>
                                            {
                                                <Select
                                                    options={dataYear.data}
                                                    onChange={handleYearChange}
                                                    placeholder='Year'
                                                    value={{ value: selectedYear, label: selectedYear }}
                                                    isSearchable={false}
                                                    aria-label="Vehicle Year"
                                                />
                                            }
                                            {
                                                !isLoading ? "" : <div className="loader"></div>
                                            }
                                        </div>

                                        <div className='selectMainDiv'>
                                            {
                                                <Select
                                                    menuIsOpen={isOpenMake}
                                                    options={dataMake.data}
                                                    onChange={handleMakeChange}
                                                    openMenuOnClick={true}
                                                    placeholder='Make'
                                                    // value={{value: vehicalDetails.make, label: vehicalDetails.make_name}}
                                                    value={{ value: selectedMake, label: selectedMakeName }}
                                                    onMenuOpen={() => setisOpenMake(true)}
                                                    onMenuClose={() => setisOpenMake(false)}
                                                    ref={makeRef}
                                                    isSearchable={false}
                                                    aria-label="Vehicle Make"
                                                />
                                            }

                                            {isLoaderMake ? "" : <div className="loaderMake"></div>}
                                        </div>


                                        <div className='selectMainDiv'>
                                            {
                                                <Select
                                                    menuIsOpen={isOpenModel}
                                                    options={dataModel.data}
                                                    onChange={handleModelChange}
                                                    openMenuOnClick={true}
                                                    placeholder='Model'
                                                    // value={{value: vehicalDetails.model, label: vehicalDetails.model_name}}
                                                    value={{ value: selectedModel, label: selectedModelName }}
                                                    onMenuOpen={() => setisOpenModel(true)}
                                                    onMenuClose={() => setisOpenModel(false)}
                                                    ref={modelRef}
                                                    isSearchable={false}
                                                    aria-label="Vehicle Model"
                                                />
                                            }
                                            {isLoaderModel ? "" : <div className="loaderModel"></div>}

                                        </div>


                                        <div className='selectMainDiv'>
                                            {
                                                <Select
                                                    menuIsOpen={isOpenVarient}
                                                    // menuIsOpen={true}
                                                    options={dataModelVarient.data}
                                                    onChange={handleVarientChange}
                                                    openMenuOnClick={true}
                                                    placeholder='Sub Model'
                                                    value={{ value: selectedVariant, label: selectedVariantName }}
                                                    onMenuOpen={() => setisOpenVarient(true)}
                                                    onMenuClose={() => setisOpenVarient(false)}
                                                    ref={variantRef}
                                                    isOptionSelected={isOptionSelected}
                                                    isSearchable={false}
                                                    aria-label="Vehicle Sub Model"
                                                />
                                            }
                                            {isLoaderVarient ? "" : <div className="loaderVarient"></div>}

                                        </div>

                                        {
                                            !selectedModel ?
                                                (<button className="serch-btn" disabled>

                                                    <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                            fill="white"></path>
                                                        <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                            fill="white"></path>
                                                        <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                            fill="white"></path>
                                                        <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                            fill="white"></path>
                                                        <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                            fill="white"></path>
                                                    </svg>
                                                    <img className="wheel_gif_icon" src="/images/wheel_ic_gif.gif" alt="gif_icon" height="100%" width="100%"></img>
                                                    Search
                                                </button>)

                                                :

                                                <button className="serch-btn" onClick={() => handleShow()} >

                                                    <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                            fill="white"></path>
                                                        <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                            fill="white"></path>
                                                        <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                            fill="white"></path>
                                                        <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                            fill="white"></path>
                                                        <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                            fill="white"></path>
                                                    </svg>
                                                    <img className="wheel_gif_icon" src="/images/wheel_ic_gif.gif" alt="gif_icon" height="100%" width="100%"></img>
                                                    Search
                                                </button>
                                        }
                                    </div>
                                </div>
                                <div className={`tab-pane fade animate__fadeIn ${activeTab === 1 ? 'show active' : ''}`} id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                                    <div className="mian-inner-data-tab position-relative d-flex wheelSearchInnerDiv">
                                        <div className='selectMainDiv'>
                                            <Select
                                                options={daimeterData}
                                                onChange={handleDiameterChange}
                                                placeholder='Diameter'
                                                value={{ value: selectedDiameter, label: selectedDiameter }}
                                                isSearchable={false}
                                                aria-label="Wheel Diameter"
                                            />

                                        </div>

                                        <div className='selectMainDiv'>

                                            <Select
                                                options={wheelWidthData.data}
                                                onChange={handleWidthChange}
                                                placeholder='Width'
                                                value={{ value: selectedWheelWidth, label: selectedWheelWidth }}
                                                onMenuOpen={() => setisOpenWheelWidth(true)}
                                                onMenuClose={() => setisOpenWheelWidth(false)}
                                                menuIsOpen={isOpenWheelWidth}
                                                ref={widthRef}
                                                isSearchable={false}
                                                aria-label="Wheel Width"
                                            />

                                            {isLoaderMake ? "" : <div className="loaderMake"></div>}
                                        </div>

                                        <div className='selectMainDiv'>
                                            <Select
                                                options={wheelLugPatternData.data}
                                                onChange={handleLugPatternChange}
                                                placeholder='Bolt Pattern'
                                                value={{ value: selectedWheelLugPattern, label: selectedWheelLugPattern }}
                                                onMenuOpen={() => setisOpenWheelLugPattern(true)}
                                                onMenuClose={() => setisOpenWheelLugPattern(false)}
                                                menuIsOpen={isOpenWheelLugPattern}
                                                ref={lugRef}
                                                isSearchable={false}
                                                aria-label="Wheel Bolt Pattern"
                                            />
                                            {isLoaderModel ? "" : <div className="loaderModel"></div>}
                                        </div>

                                        <div className='selectMainDiv'>

                                            <Select
                                                options={wheelBrandData.data}
                                                onChange={handleBrandChange}
                                                placeholder='Wheel Brand'
                                                value={{ value: selectedWheelBrand, label: selectedWheelBrandName }}
                                                onMenuOpen={() => setisOpenWheelBrand(true)}
                                                onMenuClose={() => setisOpenWheelBrand(false)}
                                                menuIsOpen={isOpenWheelBrand}
                                                ref={brandidRef}
                                                isSearchable={false}
                                                aria-label="Wheel Brand"
                                            />
                                            {isLoaderVarient ? "" : <div className="loaderVarient"></div>}

                                        </div>
                                        {
                                            selectedWheelLugPattern == 'Wheel Pattern' ?
                                                (<button className="serch-btn" disabled>

                                                    <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                            fill="white"></path>
                                                        <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                            fill="white"></path>
                                                        <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                            fill="white"></path>
                                                        <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                            fill="white"></path>
                                                        <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                            fill="white"></path>
                                                    </svg>
                                                    <img className="wheel_gif_icon" src="/images/wheel_ic_gif.gif" alt="gif_icon" height="100%" width="100%"></img>
                                                    Search
                                                </button>)

                                                :
                                                <>
                                                    <button className="serch-btn wheelSerachButton" onClick={handleWheelsSubmit} >

                                                        <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                                fill="white"></path>
                                                            <path
                                                                d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                                fill="white"></path>
                                                            <path
                                                                d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                                fill="white"></path>
                                                            <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                                fill="white"></path>
                                                            <path
                                                                d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                                fill="white"></path>
                                                            <path
                                                                d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                                fill="white"></path>
                                                            <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                                fill="white"></path>
                                                            <path
                                                                d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                                fill="white"></path>
                                                            <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                                fill="white"></path>
                                                            <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                                fill="white"></path>
                                                            <path
                                                                d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                                fill="white"></path>
                                                        </svg>
                                                        <img className="wheel_gif_icon" src="/images/wheel_ic_gif.gif" alt="gif_icon" height="100%" width="100%"></img>
                                                        Search
                                                        {
                                                            !isLoading ? "" : <div className="loader"></div>
                                                        }
                                                    </button>

                                                </>

                                        }
                                    </div>
                                </div>
                                <div className={`tab-pane fade animate__fadeIn ${activeTab === 2 ? 'show active' : ''}`} id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                                    <div className="mian-inner-data-tab position-relative d-flex wheelSearchInnerDiv">
                                        <div className='selectMainDiv'>
                                            <Select
                                                options={tireWidthData.data}
                                                onChange={handleTireWidthChange}
                                                placeholder='Tire Height'
                                                value={{ value: selectedTireWidth, label: selectedTireWidth }}
                                                isSearchable={false}
                                                aria-label="Tire Height"
                                            />
                                        </div>



                                        <div className='selectMainDiv'>
                                            <Select
                                                options={tireRatioData.data}
                                                onChange={handleTireRatioChange}
                                                placeholder='Aspect Ratio'
                                                value={{ value: selectedTireRatio, label: selectedTireRatio }}
                                                isSearchable={false}
                                                ref={ratioRef}
                                                menuIsOpen={isOpenTireRatioData}
                                                onMenuOpen={() => setisOpenTireRatioData(true)}
                                                onMenuClose={() => setisOpenTireRatioData(false)}
                                                aria-label="Tire Aspect Ratio"
                                            />
                                        </div>


                                        <div className='selectMainDiv'>
                                            <Select
                                                options={tireDiameterData.data}
                                                onChange={handleTireDiameterChange}
                                                placeholder='Wheel Diameter'
                                                value={{ value: selectedTireDiameter, label: selectedTireDiameter }}
                                                isSearchable={false}
                                                ref={tireDiameterRef}
                                                menuIsOpen={isOpenTireDiameterData}
                                                onMenuOpen={() => setisOpenTireDiameterData(true)}
                                                onMenuClose={() => setisOpenTireDiameterData(false)}
                                                aria-label="Tire Diameter"
                                            />
                                        </div>


                                        <div className='selectMainDiv'>
                                            <Select
                                                options={tireBrandData.data}
                                                onChange={handleTireBrandChange}
                                                placeholder='Tire Brand'
                                                value={{ value: selectedTireBrand, label: selectedTireBrandName }}
                                                isSearchable={false}
                                                ref={tireBrandRef}
                                                menuIsOpen={isOpenTireBrandData}
                                                onMenuOpen={() => setisOpenTireBrandData(true)}
                                                onMenuClose={() => setisOpenTireBrandData(false)}
                                                aria-label="Tire Brand"
                                            />
                                        </div>


                                        {
                                            !selectedTireWidth || selectedTireWidth == "Tire Width" || !selectedTireDiameter || selectedTireDiameter == "Tire Diameter" || !selectedTireRatio || selectedTireRatio == "Tire Ratio" ?
                                                (<button className="serch-btn" disabled>

                                                    <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                            fill="white"></path>
                                                        <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                            fill="white"></path>
                                                        <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                            fill="white"></path>
                                                        <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                            fill="white"></path>
                                                        <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                            fill="white"></path>
                                                    </svg>
                                                    <img className="wheel_gif_icon" src="/images/wheel_ic_gif.gif" alt="gif_icon" height="100%" width="100%"></img>
                                                    Search
                                                </button>)

                                                :
                                                <>
                                                    <button className="serch-btn wheelSerachButton" onClick={handleTireSubmit} >

                                                        <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                                fill="white"></path>
                                                            <path
                                                                d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                                fill="white"></path>
                                                            <path
                                                                d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                                fill="white"></path>
                                                            <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                                fill="white"></path>
                                                            <path
                                                                d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                                fill="white"></path>
                                                            <path
                                                                d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                                fill="white"></path>
                                                            <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                                fill="white"></path>
                                                            <path
                                                                d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                                fill="white"></path>
                                                            <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                                fill="white"></path>
                                                            <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                                fill="white"></path>
                                                            <path
                                                                d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                                fill="white"></path>
                                                        </svg>
                                                        <img className="wheel_gif_icon" src="/images/wheel_ic_gif.gif" alt="gif_icon" height="100%" width="100%"></img>
                                                        Search
                                                        {
                                                            !isLoading ? "" : <div className="loader"></div>
                                                        }
                                                    </button>

                                                </>

                                        }

                                    </div>
                                </div>
                            </div>
                            <div className="bottom-data">
                                <p> <a href="categories-home/all-category" className='text-decoration-none'> SHOP BY PRODUCT </a> <span>({parseInt(dataProducts).toLocaleString('en-US')})</span></p>
                                <p className='brandShop'>
                                    <a href='/brands' className='text-decoration-none'>
                                        SHOP BY BRAND </a><span>({parseInt(dataBrands).toLocaleString('en-US')})</span>

                                </p>


                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* <!-- banner section end  --> */}
            <Modal show={show} onHide={handleClose} centered size="xl" className='categoryModel'>
                <Modal.Header closeButton>
                    {/* <Modal.Title>Select Category</Modal.Title> */}
                </Modal.Header>
                <Modal.Body>
                    {
                        loader ?
                            <Loader center />
                            :
                            ""
                    }

                    <div className="container">
                        {errorMessage}
                        <div className="row">
                            {!isLoadingCategory && dataCategory ? (
                                dataCategory.data.data.categories.map((item, index) => (
                                    <div className="col-md-2" key={item.id} style={{ cursor: 'pointer' }}>
                                        <div className="category-item popupImagesDiv" onClick={() => handleChangePage(item.id)}>
                                            <div
                                                style={{ position: 'relative' }}
                                            >
                                                <img
                                                    src={"/category/" + item.image}
                                                    alt={item.image}
                                                    style={{ width: '100%' }}
                                                />

                                            </div>
                                            {/* <label>{item.name}</label> */}
                                            <h6 className="catigrious-name">{item.name}</h6>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                Array.from({ length: 18 }).map((_, idx) => (
                                    <div className="col-md-2" key={idx}>
                                        <ShimmerThumbnail height={150} rounded />
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showWheel} onHide={handleCloseWheel} centered>
                <Modal.Body>
                    <div className="container">
                        <div className="row">
                            {
                                !isLoadingFmkData && fmkApiData ?
                                    <>
                                        <div className='diameterDiv'>
                                            <div> <strong>CHOOSE YOUR DESIRED SIZE</strong> </div>
                                            <div className="row">
                                                {
                                                    fmkApiData.vehicleChassis.vehiclePlusSizes ?
                                                        uniqueRimDiameters.map((item, index) => (
                                                            <div className="col-md-3" key={item}>
                                                                <li onClick={() => handleClickDiameter(item)}>{item}"</li>
                                                            </div>

                                                        ))
                                                        :

                                                        <div className='diameterDiv'>

                                                            <div className="row">
                                                                <div className="col-md-3 text-centre">
                                                                    <span>"No Data Found Search again!"</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    </>
                                    :

                                    <div className='diameterDiv'>
                                        <div> <ShimmerBadge width={120} /> </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <ShimmerThumbnail height={50} rounded />
                                            </div>

                                            <div className="col-md-3">
                                                <ShimmerThumbnail height={50} rounded />
                                            </div>

                                            <div className="col-md-3">
                                                <ShimmerThumbnail height={50} rounded />
                                            </div>

                                            <div className="col-md-3">
                                                <ShimmerThumbnail height={50} rounded />
                                            </div>
                                        </div>
                                    </div>


                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}
